<template>
  <div class="final-table">
    <ScheduleFinalTableItem
      v-for="item in orderedItems"
      :key="item.id"
      :item="item"
    />
  </div>
</template>

<script>
import ScheduleFinalTableItem from "./ScheduleFinalTableItem";

export default {
  name: "ScheduleFinalTable",
  components: {
    ScheduleFinalTableItem
  },
  data: () => ({
    items: [
      {
        id: 1,
        title: "12 февраля",
        value: "Москва",
        address: "СК «Искра»<br>Сельскохозяйственная ул., 26, стр. 2",
        order: 10
      },
      // {
      //   id: 3,
      //   title: "6 февраля",
      //   value: "Воронеж",
      //   address: "Площадь Ленина",
      //   order: 10
      // },
      // {
      //   id: 4,
      //   title: "6 февраля",
      //   value: "Владимир",
      //   address: `ЦПКиО,  каток «Ералаш»`,
      //   order: 20
      // },
      {
        id: 5,
        title: "26 февраля",
        value: "Екатеринбург",
        address: `Стадион "Юность"<br>ул. Куйбышева, 32А`,
        order: 40
      },
      // {
      //   id: 6,
      //   title: "7 февраля",
      //   value: "Магнитогорск",
      //   address: `ул. Лесопарковая, 1/2`,
      //   order: 40
      // },
      // {
      //   id: 7,
      //   title: "13 февраля",
      //   value: "Новосибирск",
      //   address: `Залесского 3, Стадион СГУПС`,
      //   order: 50
      // },
      {
        id: 2,
        title: "20 февраля",
        value: "Санкт-Петербург",
        address: "Стадион им. Б.А. Шилова<br>ул. Демьяна Бедного, 19, корп. 2",
        order: 20
      },
      // {
      //   id: 9,
      //   title: "14 февраля",
      //   value: "Пермь",
      //   address: `Стадион "Юность" - ул. Революции, 27`,
      //   order: 70
      // },
      {
        id: 10,
        title: "19 февраля",
        value: "Казань",
        address: `Стадион «Трудовые резервы»<br>ул. Николая Ершова, 7А`,
        order: 30
      }
    ]
  }),
  computed: {
    orderedItems() {
      return [...this.items].sort((a, b) => a.order - b.order);
    }
  }
};
</script>

<style lang="scss">
.final-table {
  display: flex;
  flex-wrap: wrap;
}
</style>
